import { ContentItemDataPost, ContentItemType } from '../../types/content/contentItems'
import api from '../api'

export const fetchContentItemList = async ({ id }: { id: string }) => {
  const res = await api.get(`/content/${id}/items/`, {})
  return res.data
}

// Normalize payloads before sending to backend
const normalizeContentItemPayload = (contentItem: ContentItemDataPost): any => {
  if (contentItem.type === ContentItemType.LearningCheckbox) {
    const anyItem: any = contentItem as any
    const normalized: any = {
      type: contentItem.type,
      index: contentItem.index,
    }
    if (anyItem.page) normalized.page = anyItem.page
    // Map possible sources to 'label' and strip any accidental 'checkbox' key
    normalized.label = anyItem.label ?? anyItem.checkbox ?? anyItem.text ?? ''
    return normalized
  }
  return contentItem
}

export const addContentItem = async (id: string, contentItem: ContentItemDataPost) => {
  let res
  const payload = normalizeContentItemPayload(contentItem)
  if (payload.type == ContentItemType.Media) {
    res = await api.post(`/content/${id}/items/`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } else {
    res = await api.post(`/content/${id}/items/`, payload)
  }
  return res.data
}

export const fetchContentItem = async (id: string, itemId: string) => {
  const res = await api.get(`/content/${id}/items/${itemId}/`)
  return res.data
}

export const updateContentItem = async (id: string, itemId: string, contentItem: ContentItemDataPost) => {
  const payload = normalizeContentItemPayload(contentItem)
  const res = await api.patch(`/content/${id}/items/${itemId}/`, payload)
  return res.data
}

export const patchContentItem = async (id: any, itemId: any, contentItem: ContentItemDataPost) => {
  let res
  const payload = normalizeContentItemPayload(contentItem)
  if (payload.type == ContentItemType.Media) {
    res = await api.patch(`/content/${id}/items/${itemId}/`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } else {
    res = await api.patch(`/content/${id}/items/${itemId}/`, payload)
  }
  return res.data
}

export const deleteContentItem = async (id: string, itemId: string) => {
  const res = await api.delete(`/content/${id}/items/${itemId}/`)
  return res.data
}
